'use strict';

module.exports = 0;



//////////////////
// WEBPACK FOOTER
// ./~/shortid/lib/util/cluster-worker-id-browser.js
// module id = 486
// module chunks = 5 7 8 9 10 11 13 22 23 24 25 29 57 58